import { Restriction } from '@/models/restriction';
import { UserRestriction } from '@/models/user-restriction';
import { Nullable } from '@starsoft/common/interfaces';

export type UserRestrictionsStateProps = {
  userRestrictions: UserRestriction[];
  restriction: Nullable<Restriction>;
};

export enum UserRestrictionsActions {
  Set = 'user-restrictions/set',
  Unset = 'user-restrictions/unset',
  SetUnreachableRestriction = 'user-restrictions/set-unreachable-restriction',
}

export interface UserRestrictionsBasePayload<
  T extends UserRestrictionsActions,
  V = null,
> {
  type: T;
  payload: V;
}
export type SetUserRestrictionsPayload = UserRestrictionsBasePayload<
  UserRestrictionsActions.Set,
  Nullable<UserRestriction>
>;

export type SetUnreachableRestrictionPayload = UserRestrictionsBasePayload<
  UserRestrictionsActions.SetUnreachableRestriction,
  Nullable<Restriction>
>;

export type UnsetUserRestrictionsPayload = UserRestrictionsBasePayload<
  UserRestrictionsActions.Unset,
  Nullable<void>
>;

export type UserRestrictionsStatePayload =
  | SetUserRestrictionsPayload
  | SetUnreachableRestrictionPayload
  | UnsetUserRestrictionsPayload;
